import * as fromDatatype from '../datatype-library/index';

export interface app_device_profile_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  model_code: fromDatatype.VarcharDatatypeInterface;
  model_name: fromDatatype.VarcharDatatypeInterface;
  platform_name: fromDatatype.VarcharDatatypeInterface;
  platform_version: fromDatatype.VarcharDatatypeInterface;
  id_serial: fromDatatype.VarcharDatatypeInterface;
  id_imei: fromDatatype.VarcharDatatypeInterface;
  id_advertising: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
}

export class app_device_profile_RowClass implements app_device_profile_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  model_code: fromDatatype.VarcharDatatypeInterface;
  model_name: fromDatatype.VarcharDatatypeInterface;
  platform_name: fromDatatype.VarcharDatatypeInterface;
  platform_version: fromDatatype.VarcharDatatypeInterface;
  id_serial: fromDatatype.VarcharDatatypeInterface;
  id_imei: fromDatatype.VarcharDatatypeInterface;
  id_advertising: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
}
